import { Typography, styled } from '@mui/material';

export const SingleOrderTypography = styled(Typography)(() => ({
  fontSize: '14px'
}));
